import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-surveyor-details',
  templateUrl: './surveyor-details.component.html',
  styleUrls: ['./surveyor-details.component.css']
})
export class SurveyorDetailsComponent implements OnInit {

  @Input() surveyorName="";
  @Input() surveyorPhone= "";


  constructor() { }

  ngOnInit(): void {
  }

}
